<template>
	<div>
	<v-toolbar flat color="white" dense style="margin-bottom:0px">
    <v-btn color="green" class="white--text"  small v-on:click="dialog=true"><v-icon small>mdi-filter</v-icon>filter</v-btn>
		<v-btn color="red" class="white--text" :disabled="selectedOrders.length==0" small @click="executives.length?selectExecutive=true:pickup()">Mark as picked up</v-btn>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>

      <div style="width:200px;">
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        hide-details

      ></v-text-field>
    </div>
	</v-toolbar>
	<v-data-table
            
            :headers="headers"
            v-model="selectedOrders"
            :items="filtered"
            :search="search"
            :loading="true"
            item-key="id"
            dense
            select-all="primary"
            class="elevation-1 orders-table"
          >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
            
              <div
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              />
               <div
                class="caption"
                v-text="header.desc"/>

            </template>
             
            <template
              slot="items"
              slot-scope="props"
              >
              <td>
<v-checkbox
            v-model="props.selected"
            primary
            hide-details
          ></v-checkbox>
          
        </td>
              <td>
               
              {{props.item.tracking_id}}</td>
              <td>
                <table>
            <tr :key="itm.id" v-for="itm in props.item.items">
              <td :rowspan="itm.variants.length || 1">
                {{ itm.name }} <br />
                <small class="grey--text">
                  Price: Rs. {{ discountedPrice(itm) }}
                </small>
              </td>
              <td v-if="!itm.variants.length" :colspan="3"></td>
              <template v-for="v in itm.variants">
                <td :key="v.id + 'a'">{{ v.label }}</td>
                <td :key="v.id + 'b'">{{ v.value.name }}</td>
                <td :key="v.id + 'c'">{{ v.value.price }}</td>
              </template>
              <td :rowspan="itm.variants.length || 1">
                {{ itm.quantity }}
              </td>
              <td :rowspan="itm.variants.length || 1">
                Rs. {{ itm.quantity * discountedPrice(itm) }}
              </td>
            </tr>
          </table>
              </td>
              <td>{{props.item.address.name}} <br/>
               {{props.item.address.house_number}} <br/>
             {{props.item.address.apartment}} <br/>
           {{props.item.address.area}} <br/>
         {{props.item.address.city}} - {{props.item.address.pincode}} <br/>
          Phone - {{ props.item.address.phone }} <br />
         </td>
         <td class="text-xs-center">{{ props.item.payment_method }}</td>
          <td class="text-xs-right"><strong>Rs. {{ props.item.grand_total }}</strong></td>
              <td class="text-xs-center text-no-wrap">{{ new Date(props.item.date).toLocaleDateString() }}</td>
               <td class="text-xs-center text-no-wrap">{{props.item.delivery_date? new Date(props.item.delivery_date).toLocaleDateString():'-' }}</td>
                <td v-if="config.type==='grocery'" class="text-xs-center text-no-wrap">{{ props.item.delivery_time_slot }}</td>
                
              
            </template>
          </v-data-table>
          <v-dialog v-model="selectExecutive" width="500">
            <v-card>
              <v-card-title>
          <span class="headline text-primary">Select Delivery Executive</span>
        </v-card-title>
              <v-form v-model="valid">
              <v-card-text>
                <v-select
                v-model="executive"
                :items="executives"
                item-text="name"
                item-value="id"
                label="Select Delivery Executive"
                :rules="rules.required"
                >
              </v-select>
            </v-card-text>
          </v-form>
            <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" flat @click.native="selectExecutive = false">Cancel</v-btn>
          <v-btn color="primary darken-1" :disabled="!valid" flat @click.native="pickup()">Ok</v-btn>
        </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-text>
                <v-layout>
                  <v-flex xs12>
                    <v-select
                     v-model="filter.payment_mode"
                     :items="['all','online','cod']"
                     label="Payment Mode"
                    >
                    </v-select>
                     <v-dialog
        ref="date"
        v-model="modal"
        :return-value.sync="filter.date"
        persistent
        lazy
        full-width
        width="290px"
      >
        <template slot="activator" slot-scope="{ on }">
          <v-text-field
            v-model="filter.date"
            label="Delivery Date"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="filter.date" scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.date.save(filter.date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
                <v-select
                     v-model="filter.time_slot"
                     :items="time_slots"
                     label="Delivery Time Slot"
                     v-if="config.type==='grocery'"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>
      </div>
</template>
<script type="text/javascript">
import api from '@/api'
	export default{
    data(){
      return{
    search:"",
    selectedOrders:[],
    headers: [],
    dialog:false,
    valid:false,
    selectExecutive:false,
    executive:'',
    rules:{
      required:[v => /^(?!\s*$).+/.test(v) || 'Field is required'],

    },
    modal:false,
    filter:{
      payment_mode:'all',
      date:'',
      time_slot:''
    }
  }
  },
  computed:{
    time_slots(){
      if(this.$store.state.vid)
      return this.$store.state.vendors.find(v=>v.id==this.$store.state.vid).timeslots
      else
        return []
  },
    filtered(){
      return this.orders.filter(o=>{
        return (this.filter.time_slot==o.delivery_time_slot||!this.filter.time_slot)&&(this.filter.payment_mode=='all'||this.filter.payment_mode==o.payment_mode)&&(new Date(this.filter.date).setHours(0,0,0,0)==new Date(o.delivery_date).setHours(0,0,0,0)||!this.filter.date)
      })
    },
    config() {
      return this.$store.getters.config;
    },
  },
    props:['orders','executives'],
  methods:{
    pickup(){
      var ids=[]
      this.selectedOrders.forEach(i=>{
        ids.push(i.id)
      })
      this.$emit('updateState',{order_ids: ids, stage: 3,delivery_executive:this.executive})
      this.selectedOrders=[]
      this.selectExecutive=false
    }

  },
  created(){
    
    this.headers=[
    {
        sortable: false,
        text: 'Order Id',
        value: 'id'
      },
      {
        sortable: false,
        text: 'Items',
        value: 'items',
        desc:"Name Label Qty Price"
      },
      {
        sortable: false,
        text: 'Buyer Details',
        value: 'address'
      },
      {
        sortable: false,
        text: 'Payment Mode',
        value: 'payment_mode',
        align:"center"
      },
      {
        sortable: false,
        text: 'Amount',
        value: 'total',
        align:"center",
         desc:"Subtotal + Charges"
      },
      {
        sortable: false,
        text: 'Date',
        value: 'created',
        align:"center"
      },
      {
        sortable: false,
        text: 'Dispatch By',
        value: 'delivery_date',
        align:"center"
      },
      ];
      if (this.config.type === 'grocery')
      this.headers.push({
        sortable: false,
        text: 'Time Slot',
        value: 'delivery_time_slot',
        align: 'center',
      });
      
      
  }
  }
</script>